const round = (number: number, decimals: number): number => {
  return (
    Math.round((number + Number.EPSILON) * Math.pow(10, decimals)) /
    Math.pow(10, decimals)
  );
};

export default round;

